import React from 'react';
import { Outlet } from 'react-router-dom';
import useScrollToTop from '../../hooks/useScrollToTop';

export default function AppShell() {
  useScrollToTop();
  return (
    <div className="app-shell">
      <Outlet />
    </div>
  );
}
